import React from 'react';

interface ArchetypeShareableCardProps {
  archetype: string;
  archetypeDescription?: string | null;
  majors: Array<{ title: string; matchValue: number }>;
}

export const ArchetypeShareableCard = React.forwardRef<HTMLDivElement, ArchetypeShareableCardProps>(
  ({ archetype, archetypeDescription, majors }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          width: 480,
          padding: 32,
          backgroundColor: '#E4DFDA',
          fontFamily: '\'Varela Round\', \'Helvetica Neue\', Arial, sans-serif',
          color: '#0B132B',
          borderRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 20,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: '#403233',
              marginBottom: 4,
            }}
          >
            My Academic Archetype
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 700,
              fontFamily: '\'Rubik\', \'Helvetica Neue\', Arial, sans-serif',
              color: '#1A709D',
            }}
          >
            {archetype}
          </div>
        </div>

        {/* Description */}
        {archetypeDescription && (
          <div
            style={{
              fontSize: 14,
              lineHeight: 1.5,
              color: '#403233',
              textAlign: 'center',
            }}
          >
            {archetypeDescription}
          </div>
        )}

        {/* Top Majors */}
        {majors.length > 0 && (
          <div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: '#403233',
                textTransform: 'uppercase' as const,
                letterSpacing: 1,
                marginBottom: 10,
                textAlign: 'center',
              }}
            >
              Top Matched Majors
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {majors.map((major, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#FFFFFF',
                    borderRadius: 8,
                    padding: '10px 16px',
                  }}
                >
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#0B132B' }}>
                    {major.title}
                  </span>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: '#1A709D',
                    }}
                  >
                    {(major.matchValue * 100).toFixed(0)}% Match
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Branding Footer */}
        <div
          style={{
            textAlign: 'center',
            borderTop: '1px solid rgba(0,0,0,0.1)',
            paddingTop: 16,
          }}
        >
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: '#1A709D',
              fontFamily: '\'Rubik\', \'Helvetica Neue\', Arial, sans-serif',
            }}
          >
            beyondegrees.ai
          </div>
          <div style={{ fontSize: 11, color: '#403233', marginTop: 4 }}>
            Discover your academic path
          </div>
        </div>
      </div>
    );
  },
);

ArchetypeShareableCard.displayName = 'ArchetypeShareableCard';
